import { render, staticRenderFns } from "./Prospects.vue?vue&type=template&id=3d5a11e8&scoped=true"
import script from "./Prospects.vue?vue&type=script&lang=js"
export * from "./Prospects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a11e8",
  null
  
)

export default component.exports